<!--
 * @Author: vince
 * @Date: 2021-08-31 19:07:07
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2022-01-04 17:14:23
 * @Description: 
-->

<template>
	<div class="sys-box">
		<el-container style="height: 100%;">
			<el-aside width="200px">
				<el-menu :default-active="active" text-color="#000" active-text-color="#fff" class="border-none" @select="menuSelect">
					<el-menu-item index="schoolReport">
						<span class="menu-label" slot="title">校级报表</span>
					</el-menu-item>
					<el-menu-item index="teacherReport">
						<span class="menu-label" slot="title">教师报表</span>
					</el-menu-item>
					<el-menu-item index="teacherPlan">
						<span class="menu-label" slot="title">教师规划</span>
					</el-menu-item>
				</el-menu>
			</el-aside>
			<router-view></router-view>
		</el-container>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {
		title() {
			return this.$route.meta.title;
		},
		active() {
			return this.$route.name;
		}
	},

	methods: {
		menuSelect(index, indexPath) {
			this.$router.push({ name: index });
		}
	}
};
</script>

<style lang='less'>
.chart-box {
	width: 100%;
	padding-bottom: 100%;
	height: 0;
	position: relative;
	overflow: hidden;
	.box {
		position: absolute;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
}
</style>